const topicItems = [
  { label: '悬疑烧脑', hot: true, count: '326' },
  { label: '国产剧', hot: true, count: '512' },
  { label: '科幻大片', hot: true, count: '189' },
  { label: '古装传奇', hot: false, count: '267' },
  { label: '喜剧合家欢', hot: false, count: '218' },
  { label: '青春校园', hot: true, count: '145' },
  { label: '动作冒险', hot: false, count: '334' },
  { label: '恐怖惊悚', hot: false, count: '89' },
  { label: '高分纪录片', hot: false, count: '156' },
  { label: '动漫番剧', hot: true, count: '275' },
  { label: '综艺热播', hot: false, count: '204' },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-400">发现大家都在讨论的影视热点</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                item.hot
                  ? 'bg-accent-500/10 border-accent-500/30 text-accent-400 hover:bg-accent-500/20'
                  : 'bg-background-100/60 border-background-300/20 text-foreground-300 hover:border-primary-500/30 hover:text-primary-400'
              }`}
            >
              {item.hot && <i className="ri-fire-line text-xs"></i>}
              <span>{item.label}</span>
              <span className={`text-xs ${item.hot ? 'text-accent-400/60' : 'text-foreground-500'}`}>
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}